import { useParams } from "react-router-dom";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import AccountantPendingTasks from "../../shared/components/projectHeadComponents/pendingTasks/accountantPendingTasks";
import AdminPendingTasks from "../../shared/components/projectHeadComponents/pendingTasks/adminPendingTasks";
import HodPendingTasks from "../../shared/components/projectHeadComponents/pendingTasks/hodPendingTasks";
import ManagerPendingTasks from "../../shared/components/projectHeadComponents/pendingTasks/managerPendingTasks";

function PhNewPendingTasks() {
  const params: any = useParams();
  const keyword: any = params?.keyword;

  useBreadcrumbs(
    {
      title:
        keyword.charAt(0).toUpperCase() +
        keyword.slice(1).toLowerCase() +
        "'s Pending Tasks",
      path: routeConstant.pendingTasks.path
        .replace(":keyword", keyword)
        .replace(":task", params?.task),
    },
    true,
    keyword
  );

  return (
    <div>
      {keyword === "admin" ? (
        <AdminPendingTasks />
      ) : keyword === "manager" ? (
        <ManagerPendingTasks />
      ) : keyword === "accountant" ? (
        <AccountantPendingTasks />
      ) : keyword === "hod" ? (
        <HodPendingTasks />
      ) : null}
    </div>
  );
}

export default PhNewPendingTasks;
